/* src/routes.js */
import UProfile from "../components/Profile.vue";
import Members from "../components/Members.vue";
import About from "../components/About.vue";
import Contact from "../components/Contact.vue";
import AdminLogin from "../components/admin/Login.vue";
import AdminForgotPassword from "../components/admin/ForgotPassword.vue";
import AdminChangePassword from "../components/admin/ChangePassword.vue";
import AdminDashboard from "../components/admin/Dashboard.vue";
import AdminShopDetails from "../components/admin/salon/SalonDetails.vue";
import AdminServices from "../components/admin/Services.vue";
import AdminMarketing from "../components/admin/Marketing.vue";

import AdminFreeTime from "../components/admin/FreeTime.vue";
import AdminExceptionTime from "../components/admin/ExceptionTime.vue";
import PortfolioPictures from "../components/admin/PortfolioPictures.vue";
import PerClientRestrictions from "../components/admin/PerClientRestrictions.vue";

import AdminBusinessLicense from "../components/admin/BusinessLicense.vue";
import Stylists from "../components/admin/Stylists.vue";
import Clients from "../components/admin/Clients.vue";
import Notifications from "../components/admin/Notifications.vue";
import OptimizeScheduling from "../components/admin/OptimizeScheduling.vue";
import AdminBook from "../components/admin/Book.vue";
import SubscriptionPayments from "../components/admin/SubscriptionPayments.vue";
import Referral from "../components/admin/Referral.vue";
import Payouts from "../components/admin/Payouts.vue";
import Search from "../components/Search.vue";
// import ContractTemplate from "../components/admin/contract_template";
import Profile from "../components/admin/Profile.vue";
import CompleteCheckout from "../components/admin/CompleteCheckout.vue";
import Accounts from "../components/admin/Accounts.vue";
import ContactUs from "../components/admin/ContactUs.vue";
import ClientBook from "../components/admin/ClientBook.vue";
import ClientPayments from "../components/admin/ClientPayments.vue";
import Reports from "../components/admin/Reports.vue";
import Payments from "../components/admin/Payments.vue";
import Policy from "../components/admin/Policy.vue";
import TeamMember from "../components/admin/TeamMember.vue";
import AdminTeamMembers from "../components/admin/salon/SalonTeamMembers.vue";

import Sales from "../components/Sales.vue";
import SalesGetStartedPage from "../components/SalesGetStartedPage.vue";
import SalesSignupPage from "../components/SalesSignup.vue";

import Salon from "../components/Salon.vue";
import ShortLogin from "../components/ShortLogin.vue";

import Register from "../components/admin/Register.vue";
import ClientAppointmentsNotifications from "../components/admin/ClientAppointmentsNotifications.vue";
import WaitingListEnroll from "../components/admin/waiting-list-pages/WaitingListEnroll.vue";
import WaitingListDashboard from "../components/admin/waiting-list-pages/WaitingListDashboard.vue";
import WaitingListClients from "../components/admin/waiting-list-pages/WaitingListClients.vue";
import WaitingListInvite from "../components/admin/waiting-list-pages/WaitingListInvite.vue";
import WaitingListNotifications from "../components/admin/waiting-list-pages/WaitingListNotifications.vue";
import WaitingListTransactions from "../components/admin/waiting-list-pages/WaitingListTransactions.vue";
import WaitingListSettings from "../components/admin/waiting-list-pages/WaitingListSettings.vue";
import ClientWaitingList from "../components/admin/waiting-list-pages/client/ClientWaitingList.vue";
import BillingPurchases from "../components/admin/BillingPurchases.vue";

import SocialLinks from "../components/admin/SocialLinks.vue";
import BookingWidget from "../components/admin/BookingWidget.vue";
import Transactions from "../components/admin/Transactions.vue";
import GeneralSettings from "../components/admin/GeneralSettings.vue";
import ServiceHours from "../components/admin/ServiceHours.vue";
import BlockoutUnblock from '../components/admin/BlockoutUnblock.vue'
import PortfolioVideos from "../components/admin/PortfolioVideos.vue";

import VideoTemp from "../components/VideoTemp.vue";

export default [
    { path: "/", component: Search },
    { path: "/about", component: About },
    { path: "/contact", component: Contact },
    { path: "/members", component: Members },
    { path: "/app", component: AdminDashboard },
    { path: "/app/login", component: AdminLogin },
    { path: "/app/register", component: Register },
    { path: "/app/forgot-password", component: AdminForgotPassword },
    { path: "/app/change-password", component: AdminChangePassword },

    { path: "/app/salon-details", component: AdminShopDetails },
    { path: "/app/salon-team-members", component: AdminTeamMembers },

    { path: "/app/team-member", component: TeamMember },
    { path: "/app/services", component: AdminServices, props: { sections: ["services"], showProducts: false } },
    { path: "/app/products", component: AdminServices, props: { sections: ["services"], showProducts: true } },

    { path: "/app/client-appointments-notifications", component: ClientAppointmentsNotifications },

    { path: "/sales", component: Sales },
    { path: "/get-started", component: SalesGetStartedPage },
    { path: "/sign-up", component: SalesSignupPage },

    {
        path: "/app/client-notifications-settings",
        component: Profile,
        props: { sections: ["client-notifications-settings"] },
    },

    {
        path: "/app/services/categories",
        component: AdminServices,
        props: { sections: ["categories"] },
    },

    {
        path: "/app/work-settings",
        component: GeneralSettings,
    },

    {
        path: "/app/work-settings/service-hours",
        component: ServiceHours,
    },
    {
        path: "/app/work-settings/blockout-unblock",
        component: BlockoutUnblock,
    },
    {
        path: "/app/work-settings/business-license",
        component: AdminBusinessLicense,
    },
    { path: "/app/marketing", component: AdminMarketing },
    {
        path: "/app/marketing/message-all-clients",
        component: AdminMarketing,
        props: { sections: ["message-all-clients"], smsSection: false },
    },
    {
        path: "/app/marketing/text-messages",
        component: AdminMarketing,
        props: { sections: ["message-all-clients"], smsSection: true },
    },
    {
        path: "/app/marketing/email",
        component: AdminMarketing,
        props: { sections: ["message-all-clients"], smsSection: false, emailSection: true },
    },
    {
        path: "/app/portfolio-pictures",
        component: PortfolioPictures,
    },

    {
        path: "/app/portfolio-videos",
        component: PortfolioVideos,
    },

    {
        path: "/app/per-client-restrictions",
        component: PerClientRestrictions,
    },
    {
        path: "/app/marketing/special-offers",
        component: AdminMarketing,
        props: { sections: ["special-offers"] },
    },
    {
        path: "/app/marketing/social-links",
        component: SocialLinks,
    },
    {
        path: "/app/waiting-list/enrollment",
        component: WaitingListEnroll,
    },
    {
        path: "/app/waiting-list/dashboard",
        component: WaitingListDashboard,
    },
    {
        path: "/app/waiting-list/dashboard/clients",
        component: WaitingListClients,
    },
    {
        path: "/app/waiting-list/dashboard/invite-clients",
        component: WaitingListInvite,
    },
    {
        path: "/app/waiting-list/dashboard/notifications",
        component: WaitingListNotifications,
    },
    {
        path: "/app/waiting-list/dashboard/notifications",
        component: WaitingListNotifications,
    },
    {
        path: "/app/waiting-list/dashboard/notifications",
        component: WaitingListNotifications,
    },
    {
        path: "/app/waiting-list/dashboard/transactions",
        component: WaitingListTransactions,
    },
    {
        path: "/app/waiting-list/dashboard/settings",
        component: WaitingListSettings,
    },
    {
        path: "/app/waiting-list",
        component: ClientWaitingList,
    },
    {
        path: "/app/payments/credit-cards",
        component: ClientPayments,
        props: { sections: ["credit-cards"] },
    },
    {
        path: "/app/payments/transactions",
        component: ClientPayments,
        props: { sections: ["transactions"] },
    },
    { path: "/app/block-out", component: AdminFreeTime },
    { path: "/app/exception-days", component: AdminExceptionTime },

    { path: "/app/book", component: AdminBook },
    { path: "/app/profile", component: Profile },

    { path: "/app/payments/complete-checkout", component: CompleteCheckout },

    {
        path: "/app/payments/settings",
        component: Accounts,
        props: { sections: ["payment-settings"] },
    },
    {
        path: "/app/payments/refunds",
        component: Payments,
        props: { sections: ["refunds"] },
    },
    {
        path: "/app/payments/statements",
        component: Transactions,
    },
    {
        path: "/app/policy/fees-and-policies",
        component: Policy,
        props: { sections: ["fees-and-policies"] },
    },
    {
        path: "/app/marketing/booking-widget",
        component: BookingWidget,
    },

    { path: "/app/contact-us", component: ContactUs },
    { path: "/app/stylists", component: Stylists },
    { path: "/app/payments", component: Payments },
    { path: "/app/clients", component: Clients },
    { path: "/app/work-settings/notifications", component: Notifications },
    { path: "/app/work-settings/optimize-scheduling", component: OptimizeScheduling },

    { path: "/app/subscription-payments", component: SubscriptionPayments },
    { path: "/app/referral", component: Referral },
    { path: "/app/payouts", component: Payouts },
    { path: "/app/book/:alias", component: ClientBook },
    {
        path: "/app/reports/appts",
        component: Reports,
    },

    { path: "/app/billing-purchases", component: BillingPurchases },

    { path: "/videoTemp", component: VideoTemp },

    { path: "/shop/:alias", component: Salon },
    { path: "/login", component: ShortLogin },
    { path: "/:pathMatch(.*)*", component: UProfile }, // catch-all
    { path: "/app/:pathMatch(.*)*", redirect: "/app" },
    { path: "/admin/:pathMatch(.*)*", redirect: "/app" },
];
